import { Directive } from '@angular/core';

@Directive({
    selector: '[ngfSuffix]'
})
export class SuffixDirective {}
